export default __webpack_public_path__ + "static/media/vl-logo.de72fd65.svg";